import { Component, Prop, Vue } from "vue-property-decorator";
import { Radio } from "ant-design-vue";
import classNames from "classnames";
import { fmtMsg } from "commonui";

export type RadioStateType = { value: any; i18nKey: string; sum: number; className: string };
export interface SumRadioGroupProps {
	onChangeConfirm?: (value: any) => Promise<boolean>;
	radioStates?: RadioStateType[];
	className?: string;
}

@Component({
	components: {
		Radio,
		RadioGroup: Radio.Group
	}
})
export default class SumRadioGroup extends Vue {
	@Prop({ default: [] }) states!: RadioStateType[];
	@Prop() className?: string;
	@Prop() onChangeConfirm!: (value: any) => Promise<boolean>;
	oldValue: any;
	value: any = 0;
	get mergedClass() {
		return classNames("sum-radio-group", this.className);
	}

	get defaultValue() {
		this.oldValue = this.states[0].value;
		return this.oldValue;
	}

	onRadioChange(e: any) {
		const setValue = () => {
			this.oldValue = this.value;
			this.$emit("change", e.target.value);
		};
		const resetValue = () => {
			this.value = this.oldValue;
		};
		if (this.onChangeConfirm) {
			this.onChangeConfirm(e.target.value)
				.then((result) => (result ? setValue() : resetValue()))
				.catch((_) => resetValue());
		} else {
			setValue();
		}
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	renderState(i18nKey: string, sum: number) {
		return `<span>${this.localizedString(i18nKey)}</span>
                <span class="cnt">(${sum || 0})</span>`;
	}
}
